export default{
  permissions: (state) => state.permissions,
  permission: (state) => state.permission,
  permissionHelpers: (state) => state.permissionHelpers
}



// WEBPACK FOOTER //
// ./src/components/permission/store/getters.js